import React from "react";
import { Users, ShieldCheck, MapPin, UserCheck, FileCheck2 } from "lucide-react";
import { STATS, FEATURES } from "../mock";

const ICONS = { Users, ShieldCheck, MapPin, UserCheck, FileCheck2 };

export default function TrustFeatures() {
  return (
    <section className="bg-[#fdfaf7]">
      <div className="max-w-7xl mx-auto px-5 py-16">
        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {STATS.map((s) => {
            const Icon = ICONS[s.icon];
            return (
              <div key={s.label} className="rounded-2xl border border-black/[0.07] bg-white px-6 py-7 text-center">
                <div className="w-10 h-10 mx-auto rounded-full bg-[#f7e4e6] flex items-center justify-center">
                  <Icon className="w-5 h-5 text-[#7c2233]" strokeWidth={1.8} />
                </div>
                <div className="font-display text-3xl text-[#1f1a1b] mt-3">{s.value}</div>
                <div className="text-sm text-[#8a8285] mt-1">{s.label}</div>
              </div>
            );
          })}
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-14">
          {FEATURES.map((f) => {
            const Icon = ICONS[f.icon];
            return (
              <div key={f.title} className="rounded-2xl border border-black/[0.07] bg-white p-7 transition-shadow hover:shadow-[0_18px_40px_-24px_rgba(31,26,27,0.35)]">
                <div className="w-12 h-12 rounded-xl bg-[#f7e4e6] flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[#7c2233]" strokeWidth={1.7} />
                </div>
                <h3 className="font-display text-xl text-[#1f1a1b] mt-4">{f.title}</h3>
                <p className="text-[15px] text-[#5a5254] mt-2 leading-relaxed">{f.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
